import { render, staticRenderFns } from "./MotionProgress.vue?vue&type=template&id=87af431e"
import script from "./MotionProgress.vue?vue&type=script&lang=js"
export * from "./MotionProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports